<template>
  <div>
    <div v-if="platform == 'pc'" class="pc">
      <div v-for="field in formData" :key="field.fieldName">
        <sk-select
          v-if="field.displayType == 4"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-result.sync="field.result"
          @change="valueChange"
        />
        <sk-radio
          v-if="field.displayType == 3"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          @change="valueChange"
        />
        <sk-checkbox-select
          v-else-if="field.displayType == 6"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-result.sync="field.result"
          @change="valueChange"
        />
        <sk-checkbox
          v-else-if="field.displayType == 5"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          @change="valueChange"
        />
        <sk-img
          v-else-if="field.displayType == 7"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          @change="valueChange"
        />
        <sk-file
          v-else-if="field.displayType == 8"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          @change="valueChange"
        />
        <sk-input
          v-else-if="field.displayType == 1"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :sms-type="'customForm'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          @change="valueChange"
        />
        <sk-textarea
          v-else-if="field.displayType == 2"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          @change="valueChange"
        />
        <sk-date-picker
          v-if="field.fieldType == 'DATETIME' && field.displayType == 9"
          :field="field"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field-value.sync="field.value"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-result.sync="field.result"
          @change="valueChange"
        />
        <sk-line v-if="field.fieldType === 'LINE'" />
        <sk-desc
          v-if="field.fieldType === 'DESC'"
          :field="field"
          :field-result.sync="field.result"
          @change="valueChange"
          v-show="field.isShow"
        />

        <sk-radio-img
          v-if="field.type == 9"
          v-show="field.isShow"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          @change="valueChange"
        />
        <sk-checkbox-img
          v-if="field.type == 10"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          @change="valueChange"
        />
        <sk-policy
          v-if="field.fieldType == 'POLICY'"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          @change="valueChange"
        />
      </div>
    </div>
    <div v-if="platform == 'wap'" class="wap">
      <div v-for="field in formData" :key="field.fieldName">
        <sk-select-wap
          v-if="field.displayType == 4"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-result.sync="field.result"
          @change="valueChange"
        />
        <sk-radio-wap
          v-if="field.displayType == 3"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          @change="valueChange"
        />
        <sk-checkbox-select-wap
          v-else-if="field.displayType == 6"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-result.sync="field.result"
          @change="valueChange"
        />
        <sk-checkbox-wap
          v-else-if="field.displayType == 5"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          @change="valueChange"
        />
        <sk-img-wap
          v-else-if="field.displayType == 7"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          @change="valueChange"
        />
        <sk-file-wap
          v-else-if="field.displayType == 8"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-result.sync="field.result"
          @change="valueChange"
        />
        <sk-input-wap
          v-else-if="field.displayType == 1"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :sms-type="'customForm'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          @change="valueChange"
        />
        <sk-textarea-wap
          v-else-if="field.displayType == 2"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          @change="valueChange"
        />
        <sk-date-picker-wap
          v-if="field.fieldType == 'DATETIME' && field.displayType == 9"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          @change="valueChange"
        />
        <sk-line-wap v-if="field.fieldType === 'LINE'" />
        <sk-desc-wap v-if="field.fieldType === 'DESC'" :field="field" />
        <sk-radio-img-wap
          v-if="field.type == 9"
          v-show="field.isShow"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          @change="valueChange"
        />
        <sk-checkbox-img-wap
          v-if="field.type == 10"
          v-show="field.isShow"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          @change="valueChange"
        />
        <sk-policy-wap
          v-if="field.fieldType == 'POLICY'"
          :check-flag="field.checkFlag"
          v-show="field.isShow"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
          @change="valueChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import rulesMixin from "@/mixin/optionRules";
export default {
  name: "CField",
  props: {
    formData: Array,
    platform: String,
  },
  mixins: [rulesMixin],
  computed: {
    extras() {
      return this.$store.state.extras;
    },
  },
};
</script>
